// Centralized WhatsApp + Instagram contact configuration for Vini Gems And Jewellers.
// Update numbers / links here — every component reads from this single source of truth.

export const BRAND_NAME = "Vini Gems And Jewellers";

export const WHATSAPP_NUMBERS = [
  { number: "919648888153", label: "+91 96488 88153", active: true },
  { number: "919889921486", label: "+91 98899 21486", active: true },
];

export const PRIMARY_WHATSAPP_NUMBER = WHATSAPP_NUMBERS[0].number;

export const WHATSAPP_COMMUNITY_LINK = "https://chat.whatsapp.com/JIN0r3tvzEv2PqwOzomINN";
export const INSTAGRAM_LINK = "https://www.instagram.com/vini_jewelleryinfo?igsh=a3NwZGc1bG1qOHNs";

/**
 * Builds a wa.me deep link with a pre-filled message.
 */
export function buildWhatsAppLink(message, number = PRIMARY_WHATSAPP_NUMBER) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function enquireMessage(itemName) {
  return `Hi ${BRAND_NAME}! I'm interested in "${itemName}". Could you please share more details, pricing and availability?`;
}

export function categoryEnquireMessage(categoryName) {
  return `Hi ${BRAND_NAME}! I'd like to know more about your ${categoryName} collection. Please share available designs and prices.`;
}

export function generalEnquireMessage() {
  return `Hi ${BRAND_NAME}! I'd like to enquire about your jewellery collection.`;
}
